import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { RestService } from 'src/app/services';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

export class TextToSpeechService {
    private rest = inject(RestService);
    private http = inject(HttpClient);
    
    public async getSpeechFromText(text: string){
        const apiUrl = environment.urlTextToSpeech;

        try {
            const res = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    Accept: 'text/event-stream',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ service: this.rest.device?.chatBotId ?? 0, text })
            });

            if (!res.ok) {
                const errText = await res.text().catch(() => '');
                throw new Error(`HTTP ${res.status} ${res.statusText} ${errText}`.trim());
            }

            if (!res.body)
                throw new Error('La respuesta no trae body (stream).');
            
            const reader = res.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';

            try {
                while (true) {
                    const { value, done } = await reader.read();
                    if (done) 
                        break;

                    buffer += decoder.decode(value, { stream: true });
                }
            } finally {
                reader.releaseLock();
            }

            const blob = this.getAudioBlobFromChunks([buffer]);
            return blob;

        } catch (err) {
            console.error('playFromAPI error:', err);
            throw err;
        } finally {

        }
    }

    public getAudioBlobFromChunks(audioChunks){
        const pcmData = audioChunks
            .map(chunk => atob(chunk))
            .map(binaryString => new Uint8Array(binaryString.length)
            .map((_, i) => binaryString.charCodeAt(i)))
            .reduce((acc, array) => {
                const combined = new Uint8Array(acc.length + array.length);
                combined.set(acc, 0);
                combined.set(array, acc.length);
                return combined;
            }, new Uint8Array(0));

        const wavHeader = this.createWAVHeader(pcmData.length);
        const wavData = new Uint8Array(wavHeader.length + pcmData.length);
        wavData.set(wavHeader, 0);
        wavData.set(pcmData, wavHeader.length);

        return new Blob([wavData], { type: 'audio/wav' });
    }

    private createWAVHeader(dataLength: number, sampleRate: number = 24000, numChannels: number = 1): Uint8Array {
        const byteRate = sampleRate * numChannels * 2; // 2 bytes per sample (16-bit PCM)
        const blockAlign = numChannels * 2;
    
        const buffer = new ArrayBuffer(44);
        const view = new DataView(buffer);
    
        // ChunkID "RIFF"
        this.writeString(view, 0, 'RIFF');
        view.setUint32(4, 36 + dataLength, true); // ChunkSize
        this.writeString(view, 8, 'WAVE'); // Format
    
        // Subchunk1ID "fmt "
        this.writeString(view, 12, 'fmt ');
        view.setUint32(16, 16, true); // Subchunk1Size
        view.setUint16(20, 1, true); // AudioFormat (PCM)
        view.setUint16(22, numChannels, true); // NumChannels
        view.setUint32(24, sampleRate, true); // SampleRate
        view.setUint32(28, byteRate, true); // ByteRate
        view.setUint16(32, blockAlign, true); // BlockAlign
        view.setUint16(34, 16, true); // BitsPerSample
    
        // Subchunk2ID "data"
        this.writeString(view, 36, 'data');
        view.setUint32(40, dataLength, true); // Subchunk2Size
    
        return new Uint8Array(buffer);
    }

    private writeString(view: DataView, offset: number, string: string): void {
        for (let i = 0; i < string.length; i++) {
            view.setUint8(offset + i, string.charCodeAt(i));
        }
    }

    public getWelcomeMessage(token): Observable<any> {
        const apiUrl = environment.urlWelcomeMessage;
        const params = new HttpParams().set('route_token', token);
        const headers = new HttpHeaders().set('Accept', 'application/json');
        
        return this.http.get(apiUrl, { params, headers })
    }
}